<template>
  <div class="flex items-center justify-between">
    <span
      @click="increase()"
      :class="{ 'disabled-icon': disabledMinus }"
      class="action-icon cursor-pointer"
    >
      <svg
        width="16"
        height="2"
        viewBox="0 0 14 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 2H0V0H14V2Z" fill="#1695A3" />
      </svg>
    </span>
    <input readonly :value="value" class="input-count" />
    <span
      @click="decrement()"
      :class="{ 'disabled-icon': disabledPlus }"
      class="action-icon cursor-pointer"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="#1695A3" />
      </svg>
    </span>
  </div>
</template>

<script>
import { MinusIcon, PlusIcon } from "../../../assets/icons";

export default {
  components: { MinusIcon, PlusIcon },
  props: ["value", "type"],
  computed: {
    disabledMinus() {
      return (
        (this.type === "adults" && this.value === 1) ||
        (this.type === "children" && this.value === 0)
      );
    },
    disabledPlus() {
      return this.type === "children" && this.value === 2;
    },
  },
  methods: {
    increase() {
      if (!this.disabledMinus) {
        this.$emit("input", this.value - 1);
      }
    },
    decrement() {
      if (!this.disabledPlus) {
        this.$emit("input", this.value + 1);
      }
    },
  },
};
</script>

<style scoped>
.input-count {
  width: 50px;
  text-align: center;
  background-color: transparent;
}

.action-icon {
  border: 1px solid;
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1695a3;
}

.disabled-icon {
  opacity: 0.5;
  background-color: #f2f3f3;
  cursor: not-allowed;
}
</style>
